/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { StateStatusTypeTitles } from "../../StateUIHelpers";
export const CountryTypeFormatter = (cellContent, row, rowIndex) => {
  const { countryId } = row;
  const { name = "-" } = countryId || {};
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <span className="text-dark-75 d-block text-capitalize">{`${name} `}</span>
        </div>
      </div>
      <> </>
    </>
  );
};
